export const WeddingInvitationDesignIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="32" height="32" rx="4" />
        <path
            d="M20.7058 16.5521V9.88234C20.7058 9.36254 20.2845 8.94116 19.7647 8.94116H12.2352C11.7154 8.94116 11.2941 9.36254 11.2941 9.88234V16.5521"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.8252 15.6644C21.9665 15.5522 22.1596 15.5309 22.3221 15.6093C22.4847 15.6877 22.588 15.8522 22.5882 16.0326V22.1189C22.5882 22.6387 22.1669 23.0601 21.647 23.0601H10.3529C9.83309 23.0601 9.41171 22.6387 9.41171 22.1189V16.0326C9.41187 15.8522 9.51521 15.6877 9.67772 15.6093C9.84023 15.5309 10.0333 15.5522 10.1747 15.6644L14.8373 19.3625C15.5197 19.8985 16.4801 19.8985 17.1626 19.3625L21.8252 15.6644Z"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.1176 12.7058C14.6374 12.7058 15.0588 12.2845 15.0588 11.7647C15.0588 11.2449 14.6374 10.8235 14.1176 10.8235C13.5978 10.8235 13.1764 11.2449 13.1764 11.7647C13.1764 12.2845 13.5978 12.7058 14.1176 12.7058Z"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.1177 16.4708L15.7177 13.71C15.8954 13.473 16.1744 13.3335 16.4706 13.3335C16.7668 13.3335 17.0458 13.473 17.2235 13.71L18.8235 16.4708H14.1177Z"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
